import React, { useMemo } from "react";
import withName from "../../hoc/withName";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router";
import ConnectionCard from "./ConnectionCard";
import FilterBar from "./FilterBar";
import { AG_ANALYTICS_SPA, API_KEY_SEAT, ARABLE, CDTEC_API, CERES, CERES_IMAGING, IRRIMAX, SDB_CONVERTER, USER_SEAT } from "./Services/constants";


const FarmConnections = () => {
    const { t } = useTranslation();
    const { farmConnections, setFilterData, filterData } = useOutletContext() || {};
    const filteredFarmConnections = useMemo(() => {
        if (!farmConnections?.length) return [];
        const deAccentSearch = filterData.searchText.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase();
        const prefiltered = farmConnections.filter((data) =>{
            const matchSearch = data.nombre_servicio.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase().search(deAccentSearch) !== -1;
            return matchSearch;
        });
        const filtered = prefiltered.filter((data) => ![ARABLE,IRRIMAX,SDB_CONVERTER,API_KEY_SEAT,USER_SEAT, CERES_IMAGING,CERES,CDTEC_API].includes(data.marketplace_servicio_id) &&data.marketplace_servicio_id);
        if (filterData.selectedSort === "sortDate"){
            filtered.sort((a,b) =>  new Date(b.connection_data?.created_at) - new Date(a.connection_data?.created_at));
        } else if (filterData.selectedSort === "sortProduct"){
            filtered.sort((a,b) => a.tipo_i18n.localeCompare(b.tipo_i18n));
        } else if (filterData.selectedSort === "sortCompany"){
            filtered.sort((a,b) => {
                if (a.nombre_compania === b.nombre_compania) return 0;
                if (a.nombre_compania === null) return 1;
                if (b.nombre_compania === null) return -1;
                return a.nombre_compania < b.nombre_compania ? -1 : 1;
            });
        }
        // else default sort is by product/service name
        return filtered;
    }, [farmConnections, filterData.searchText, filterData.selectedSort]);
    return (
        <div>
            <FilterBar isFarmConnections />
            { !filteredFarmConnections?.length &&
                <span className='no-data'>{t("forms.noData")}</span>}
            { Boolean(filteredFarmConnections.length) && (
                <div className='card-list'>
                    {filteredFarmConnections.map((c, id) => {
                        return (
                            <ConnectionCard
                                key={`${c.nombre_servicio}_${id}`}
                                connection={c}
                                setSelectedCategories={
                                    (value) => setFilterData( prev => ({...prev, selectedCategories: value}))
                                }
                                isEnabledCard
                            />
                        );
                    })}
                </div>
            )}
        </div>


    );
};

export default withName(FarmConnections, "FarmConnectionsFrag");

